<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "TableAckResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      companyId: "",
      accountName: "",
      resourceName: "",
      columns: [
        {
          title: this.$t("RAM.ALI.Ack.accountID"),
          minWidth: 150,
          key: "accountIdString",
        },
        {
          title: this.$t("RAM.ALI.Ack.accountName"),
          minWidth: 150,
          key: "accountName",
        },
        {
          title: this.$t("RAM.ALI.Ack.region"),
          minWidth: 150,
          key: "region",
        },
        {
          title: this.$t("RAM.ALI.Ack.accountType"),
          minWidth: 150,
          key: "accountType",
        },
        {
          title: this.$t("RAM.ALI.Ack.clusterId"),
          minWidth: 150,
          key: "clusterId",
        },
        {
          title: this.$t("RAM.ALI.Ack.clusterName"),
          minWidth: 150,
          key: "clusterName",
        },
        {
          title: this.$t("RAM.ALI.Ack.clusterType"),
          minWidth: 150,
          key: "clusterType",
        },
        {
          title: this.$t("RAM.ALI.Ack.profile"),
          minWidth: 150,
          key: "profile",
        },
        {
          title: this.$t("RAM.ALI.Ack.clusterSpec"),
          minWidth: 150,
          key: "clusterSpec",
        },
        {
          title: this.$t("RAM.ALI.Ack.vpcId"),
          minWidth: 150,
          key: "vpcId",
        },
        {
          title: this.$t("RAM.ALI.Ack.size"),
          minWidth: 150,
          key: "size"
        },
      ],
      tableData: [],
    };
  },
  beforeCreate: function () {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function (companyId) {
      tableDataVue.companyId = companyId;
    });
    eventBus.$on("accountName", function (accountName) {
      tableDataVue.accountName = accountName;
    });
    eventBus.$on("resourceName", function (resourceName) {
      tableDataVue.resourceName = resourceName;
    });
  },
  mounted: function () {
    // tableDataVue.getData();
  },
  methods: {
    showAll: function () {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function () {
      // 获取搜索内容
      eventBus.$on("companyId", function (companyId) {
        tableDataVue.companyId = companyId;
      });
      eventBus.$on("accountName", function (accountName) {
        tableDataVue.accountName = accountName;
      });
      eventBus.$on("resourceName", function (resourceName) {
        tableDataVue.resourceName = resourceName;
      });

      this.$api.resourceManagement
        .pagingQueryAliAck({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: tableDataVue.companyId,
          accountName: tableDataVue.accountName,
          resourceName: tableDataVue.resourceName,
        })
        .then((res) => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function (current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function (pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    },
  },
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/ack/TableAckResource.vue